import { render, staticRenderFns } from "./VListProductItemsCollapsable.vue?vue&type=template&id=4a9d69f2&scoped=true&"
import script from "./VListProductItemsCollapsable.vue?vue&type=script&lang=js&"
export * from "./VListProductItemsCollapsable.vue?vue&type=script&lang=js&"
import style0 from "./VListProductItemsCollapsable.vue?vue&type=style&index=0&id=4a9d69f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d69f2",
  null
  
)

export default component.exports